










































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { ProductTab, Product } from '@/models/Product';
import ItemsList from './ItemsList.vue';
import ResponsiveVideoImage from '@/components/Blocks/ResponsiveVideoImage.vue';

@Component({
    components: {
        ItemsList,
        ResponsiveVideoImage
    }
})
export default class ProductInfoTab extends Vue {
    @Prop()
    protected tab!: ProductTab;

    constructor() {
        super();

        // console.log(this.tab);
    }

    protected isUsp(text: string): boolean {
        if (text && text.length >= 3 && text.substring(0, 3) == 'USP') {
            return true;
        }

        return false;
    }
}
